import axios from 'axios';
import getTokenFromCookies from 'helpers/get-cookie';

const clearAccessToken = () => {
  document.cookie = 'access_token=; Max-Age=0; path=/';
};

const redirectToSignIn = () => {
  if (window.location.pathname !== '/authentication/sign-in/basic') {
    window.location.assign('/authentication/sign-in/basic');
  }
};

const shouldForceLogoutOnUnauthorized = (error) => {
  if (error?.response?.status !== 401) return false;
  if (error?.config?.skipAuthRedirect) return false;
  return true;
};

const useAxios = () => {
  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    withCredentials: true
  });
  axiosInstance.interceptors.request.use(
    function (config) {
      // const value = `; ${document.cookie}`;
      // let parts = value.split(`; access_token=`);
      // if (parts.length === 2) {
      //   parts = parts.pop().split(';').shift();
      // }
      const token = getTokenFromCookies();
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      } else {
        delete config.headers['Authorization'];
      }
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (shouldForceLogoutOnUnauthorized(error)) {
        clearAccessToken();
        redirectToSignIn();
      }

      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default useAxios;
